import { Container, Icon, IconButton, Typography } from '@design-system';
import { FavoriteOrder, Order, OrderStatuses } from '@services';
import { DEFAULT_IMAGE } from '@utils';
import React from 'react';
import { FaChevronDown, FaShoppingBasket } from 'react-icons/fa';
import './OrderItem.scss';
import { StatusProvider } from './StatusProvider';
import { useOrderItem } from './useOrderItem';

export const OrderItem: React.FC<
    Order & {
        isPast?: boolean;
        title?: string;
        customProducts?: Pick<FavoriteOrder, 'products'>;
        isFavorite?: boolean;
        type?: 'epi' | 'appro';
    }
> = ({ id, date_order, date_update, status, products, isPast, title, customProducts, isFavorite, type = 'appro', id_worksite }) => {
    const { navigate, toggled, setToggled, productsRef, productsToDisplay, handleReorder, worksiteInfo } = useOrderItem({
        products,
        isFavorite,
        customProducts,
        type,
        id_worksite: id_worksite.toString()
    });

    return (
        <Container
            className="order-item"
            onClick={() => {
                if (!isFavorite) {
                    if (type === 'epi') {
                        navigate(`/sante-securite/epi/cart/${id}`);
                    } else {
                        navigate(`/mes-chantiers/approvisionnement/cart/${id}`);
                    }
                }
            }}
        >
            <div className="order-item-top-wrapper">
                <div className="order-item-left">
                    <div className="order-item-status">
                        <StatusProvider
                            status={isFavorite ? OrderStatuses.FAVORITED : date_update ? OrderStatuses.UPDATED : (status as OrderStatuses)}
                        />
                    </div>
                    <div className="order-item-infos">
                        <Typography intrinsic="p" color="marine">
                            {title ? title : `Demande #${id}`}
                        </Typography>
                        {!isFavorite && (
                            <Typography intrinsic="p">
                                Effectuée le{' '}
                                {new Date(date_order).toLocaleDateString('fr-FR', {
                                    day: '2-digit',
                                    month: '2-digit',
                                    year: '2-digit'
                                })}
                            </Typography>
                        )}
                    </div>
                </div>
                {isPast && (
                    <div className="order-item-reorder">
                        <IconButton
                            icon={<Icon icon={<FaShoppingBasket />} size={24} color="green" variant="surrounded" bordered />}
                            onClick={(e) => {
                                e.stopPropagation();
                                handleReorder();
                            }}
                        />
                    </div>
                )}
            </div>
            <div
                className={`order-item-bottom-wrapper ${toggled ? 'toggled' : ''}`}
                onClick={(e) => {
                    e.stopPropagation();
                    setToggled((prevToggled) => !prevToggled);
                }}
            >
                <Typography intrinsic="p">
                    {productsToDisplay.length} {productsToDisplay.length > 1 ? 'produits' : 'produit'} ({worksiteInfo?.name})
                </Typography>
                <Icon icon={<FaChevronDown />} size={18} color="grey" />
            </div>

            <div ref={productsRef} className="order-item-products">
                {productsToDisplay.map((product) => (
                    <div className="order-item-product" key={product.id}>
                        <div className="order-item-product-left-wrapper">
                            <img src={product.image ?? DEFAULT_IMAGE} alt={product.label} />
                            <Typography intrinsic="p" color="marine" className="order-item-product-label">
                                {product.label}
                            </Typography>
                        </div>
                        <Typography intrinsic="p" variant="sub" className="order-item-product-quantity">
                            x{product.quantity}
                        </Typography>
                    </div>
                ))}
            </div>
        </Container>
    );
};
